// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getPlanbatchListActionReducer } from './getPlanbatchListAction';
import { reducer as getPlan_lngListReducer } from './getPlan_lngList';
import { reducer as submitPlan_lngReducer } from './submitPlan_lng';
import { reducer as deletePlan_lngReducer } from './deletePlan_lng';
import { reducer as plan_lngModalChangeReducer } from './plan_lngModalChange';
import { reducer as chooseCurrentPlan_lngReducer } from './chooseCurrentPlan_lng';
import { reducer as certificateCompileActionsReducer } from './certificateCompileActions';
import { reducer as certificateCompileModalChangeReducer } from './certificateCompileModalChange';
import { reducer as qualityProveModalChangeReducer } from './qualityProveModalChange';
import { reducer as qualityProveCompileActionsReducer } from './qualityProveCompileActions';
import { reducer as certificateCompileIdReducer } from './certificateCompileId';
import { reducer as qualityProveIdReducer } from './qualityProveId';
import { reducer as mediumSafetyUploadingActionsReducer } from './mediumSafetyUploadingActions';
import { reducer as mediumSafetyUploadingChooseReducer } from './mediumSafetyUploadingChoose';
import { reducer as getAllbatchActionsReducer } from './getAllbatchActions';
import { reducer as getCheckActionsReducer } from './getCheckActions';
import { reducer as getGenerateActionsReducer } from './getGenerateActions';
import { reducer as getAllQpxlListReducer } from './getAllQpxlList';
import { reducer as chooseCurrentQpxhReducer } from './chooseCurrentQpxh';
import { reducer as getAllMakeJjdwActionsReducer } from './getAllMakeJjdwActions';
import { reducer as qpdataFileUploadingChooseReducer } from './qpdataFileUploadingChoose';
import { reducer as qpDataFileUploadingActionReducer } from './qpDataFileUploadingAction';
import { reducer as buildqpdataFileActionReducer } from './buildqpdataFileAction';
import { reducer as qpParamsFileUploadChooseReducer } from './qpParamsFileUploadChoose';
import { reducer as qpParamsFileUploadingActionReducer } from './qpParamsFileUploadingAction';

const reducers = [
  getPlan_lngListReducer,
  submitPlan_lngReducer,
  deletePlan_lngReducer,
  plan_lngModalChangeReducer,
  chooseCurrentPlan_lngReducer,
  getPlanbatchListActionReducer,
  certificateCompileActionsReducer,
  certificateCompileModalChangeReducer,
  qualityProveModalChangeReducer,
  qualityProveCompileActionsReducer,
  certificateCompileIdReducer,
  qualityProveIdReducer,
  mediumSafetyUploadingActionsReducer,
  mediumSafetyUploadingChooseReducer,
  getAllbatchActionsReducer,
  getCheckActionsReducer,
  getGenerateActionsReducer,
  getAllQpxlListReducer,
  chooseCurrentQpxhReducer,
  getAllMakeJjdwActionsReducer,
  qpdataFileUploadingChooseReducer,
  qpDataFileUploadingActionReducer,
  buildqpdataFileActionReducer,
  qpParamsFileUploadChooseReducer,
  qpParamsFileUploadingActionReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/plan/redux/reducer.js